module.exports = __webpack_public_path__ + "static/media/2_Dior Bellavita - Taipei.6596e0ac.jpg";